import { Outlet } from 'react-router-dom';

import { Logo } from '@/components/branding/Logo';
import { LegalHomeLink } from '@/components/legal/LegalHomeLink';
import { LegalNavTabs } from '@/components/legal/LegalNavTabs';
import { LegalSignedInNav } from '@/components/legal/LegalSignedInNav';
import Link from '@/lib/nav/link';
import { Show } from '@/lib/auth/client-auth';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const OPEN_ROAM = cn(buttonVariants({ size: 'sm' }), 'rounded-full px-4 py-2 text-sm font-bold');

export function LegalLayout() {
  return (
    <LegalSignedInNav>
      <div className="min-h-screen bg-ivory">
        <header className="border-b border-black/8 bg-white/85 backdrop-blur">
          <div className="mx-auto max-w-4xl px-4 py-3 pl-nav-clear md:px-6 md:py-4">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <LegalHomeLink className="inline-flex shrink-0 items-center">
                <Logo
                  variant="full"
                  width={170}
                  height={62}
                  className="h-9 w-auto md:h-10"
                  priority
                />
              </LegalHomeLink>
              <Show when="signed-in">
                <Link href="/trips" className={OPEN_ROAM}>
                  Back to app
                </Link>
              </Show>
            </div>
            <LegalNavTabs className="mt-3 max-w-xl" />
          </div>
        </header>
        <main className="mx-auto max-w-3xl px-4 py-10 pl-nav-clear md:px-6 md:py-14">
          <section className="mb-12 rounded-2xl border border-primary/15 bg-white p-6 shadow-sm">
            <p className="text-[11px] font-black uppercase tracking-[0.12em] text-primary">
              Plain-English summary
            </p>
            <p className="mt-3 text-[15px] leading-7 text-ink/75">
              Roam Together helps plan family trips, but you still verify bookings, safety,
              schedules, and provider details. Payments run through Stripe, trip data lives in
              Convex, identity runs through Clerk, and some travel links may earn us a commission at
              no extra cost to you.
            </p>
          </section>
          <article className="prose max-w-none space-y-5 text-ink/85 prose-headings:font-display prose-headings:font-bold prose-headings:text-ink prose-h1:text-4xl prose-h2:mt-10 prose-h2:text-2xl prose-p:leading-7 prose-strong:text-ink prose-a:text-primary prose-a:no-underline hover:prose-a:underline">
            <Outlet />
          </article>
        </main>
      </div>
    </LegalSignedInNav>
  );
}
